<template>
  <div  class="cx-card cx-card-lg cx-overall-score-chart">
    <div v-if="scoreInfo" class="scoped-header">
      <treeselect :clearable="false"
                  v-if="scoreInfo.showTreeSelect"
                  :options="scoreInfo.scores"
                  v-model="selectedScoreId"
                  :disableFuzzyMatching="true"
                  @input="emitScoreChange()" />
      <font-awesome-icon  id="ExplainCxScore"
                          v-if="scoreInfo.showTreeSelect"
                          class="clickable scoped-icon"
                          :class="{'icon-disabled': selectedScoreId !== -1 }"
                          :icon="['far', 'search']"
                          @click="handleShowBadges($event)" />
      <div  v-if="!scoreInfo.showTreeSelect"
            class="font-weight-bold scoped-header-text">
        {{$t('Webportal.CX.OverallScore')}}
      </div>
      <b-tooltip  target="ExplainCxScore"
                  placement="bottomleft"
                  triggers="hover"
                  class="tooltip-override">
        <div v-html="$t('Webportal.CX.OverallScore.Explanation')" />
      </b-tooltip>
    </div>

    <ScoresChartControl v-if="scoreInfo"
                        class="scoped-body" 
                        :ColorRange="scoreInfo.threshold"
                        :scoreInfo="scoreInfo"
                        :Scores="getScores" 
                        :theme="theme" />
    <div v-else class="scoped-placeholder scoped-fill"> 

    </div>
  </div>

</template>

<script>
import ScoresChartControl from '../Scores.vue';
import EventBus from '@/services/EventBus'

export default {
  components: {
    ScoresChartControl
  },

  props: {
    scoreInfo:              { type: Object, default: () => undefined },
    theme:                  { type: String, default: () => 'light' },
  },

  computed: {
    getScores() {
      if (!this.scoreInfo || !this.scoreInfo.scoreData) return [];

      if (this.scoreInfo.showTreeSelect)
        return this.scoreInfo.scoreData;

      let results = [];
      let items = this.scoreInfo.scoreData.results;
      let date = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

      for (let i = 0; i < items.length; i++) {
        results.push({
          CxScore: items[i].result,
          Month: date.getMonth(),
          Year: date.getFullYear()
        });
        date.setMonth(date.getMonth() - 1);
      }
      return results;
    }
  },

  data() {
    return {
      isMounted: false,
      selectedScoreId: -1,
      showBadges: false
    }
  },

  methods: {
    emitScoreChange() {
      EventBus.$emit("Score_Changed", this.selectedScoreId);
      if (this.selectedScoreId !== -1) {
        this.showBadges = false;
        EventBus.$emit("badges", this.showBadges);
      }
    },

    handleShowBadges(event) {
      this.showBadges = !this.showBadges;
      EventBus.$emit("badges", this.showBadges);
    }
  }
}
</script>

<style scoped>
.cx-card {
  max-width: 99%;
  width: 100%;
}
.scoped-header {
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 1rem;
  padding-right: 2rem;
}
.scoped-header-text {
  padding-top: 0.25rem;
}
.scoped-placeholder{
  padding: 0.75rem;
  background-color: var(--color-secondary);
  border-radius: 0.5rem;
  margin: 0.5rem;
}
.scoped-fill {
  height: calc(100% - 3rem);
}
.scoped-body {
  background-color: transparent!important;
  padding-right: 1rem;
}
.scoped-icon {
  margin-inline: 0.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.25rem;
  width: 1.5rem;
  height: 1.5rem;
}
</style>